import React from 'react';
import { Typography } from '@mui/material';
import MarketTable from '../tables/MarketTable';

const MarketSection = () => {
  return (
    <>
      <Typography marginRight={1} marginTop={2} variant='h3'>
        Market
      </Typography>
      <MarketTable />
    </>
  );
};

export default MarketSection;
